module.exports = __webpack_public_path__ + "assets/img/dots.f8026392.svg";